import { allRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { contactAuditPageConfig } from "./contactAuditPageConfig";
import {
  adaptContactAuditRecord,
  ContactAuditTitleField,
} from "./contactAuditRecordAdapter";

export const contactAuditRecordDefinition: RecordDefinition = {
  path: "/contact-audit",
  entityName: "g4gdpr_contactaudit",
  // Audits have no list of their own; they're opened from a contact.
  listRoute: "/contacts",
  backTitle: "Back to contacts",
  allowedRoles: allRoles,
  config: contactAuditPageConfig,
  authorable: false,
  recordAdapter: adaptContactAuditRecord,
  identity: {
    titleFields: [ContactAuditTitleField],
    subtitleField: "g4gdpr_emailaddress1",
    showAvatar: true,
    avatarFields: ["g4gdpr_firstname", "g4gdpr_lastname"],
    fallbackTitle: "Contact Audit",
    newRecordTitle: "New Contact Audit",
  },
};
